import { Stack, Button as MuiButton, Typography } from '@mui/material';
import { InlineBackdrop } from '@client/components/common/Backdrop';
import { useTicketingCheck } from '@client/hooks/useTicketingCheck';
import { useShareShow } from './useShareShow.hook';
import { TicketButton } from './TicketButton';

interface TicketCTAProps {
  readonly showId: string;
}

export const TicketCTA: React.FC<TicketCTAProps> = ({ showId }) => {
  const handleShareButtonClick = useShareShow(showId);

  const [badge, canPurchaseTickets, timeLimitPast, isCollaborator] = useTicketingCheck({ showId });

  return (
    <Stack spacing={3}>
      {Boolean(timeLimitPast) && (
        <InlineBackdrop color="error">
          <Typography>
            {isCollaborator
              ? 'Tickets are no longer on sale to the public. Only the show\'s creators can see this page.'
              : 'Tickets are no longer on sale'}
          </Typography>
        </InlineBackdrop>
      )}

      <InlineBackdrop color="success">
        <Stack spacing={2}>
          <TicketButton
            showId={showId}
            badge={badge}
            canPurchaseTickets={canPurchaseTickets}
          />

          <MuiButton
            variant="outlined"
            size="large"
            color="success"
            onClick={handleShareButtonClick}
            fullWidth
          >
            Share
          </MuiButton>
        </Stack>
      </InlineBackdrop>
    </Stack>
  );
};
